
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const EmptyCart: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <Card className="bg-white shadow-md mb-6">
      <CardContent className="pt-6 flex flex-col items-center justify-center py-12">
        <ShoppingCart className="h-16 w-16 text-gray-300 mb-4" />
        <h2 className="text-xl font-medium text-tribal-secondary mb-2">Your cart is empty</h2>
        <p className="text-tribal-neutral mb-6">Add items to your cart to continue</p>
        <Button onClick={() => navigate("/")} className="bg-tribal-primary hover:bg-tribal-primary/90">
          Browse Permits
        </Button>
      </CardContent>
    </Card>
  );
};
